import { Paper } from "@mui/material";

export default function Setting() {
  return <Paper className="dashboard">Setting</Paper>;
}
